(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["valor-experience"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const setup = (root) => {
    root.querySelectorAll('[data-vx-brief-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.hidden = false;
      button.addEventListener('click', () => {
        const section = button.closest('.vx');
        const hide = button.getAttribute('aria-pressed') !== 'true';
        section.dataset.hideBriefs = String(hide);
        button.setAttribute('aria-pressed', String(hide));
        button.textContent = hide ? button.dataset.showLabel : button.dataset.hideLabel;
      });
    });
    root.querySelectorAll('[data-vx-player]').forEach(player => {
      if (player.dataset.ready) return;
      player.dataset.ready = 'true';
      const video = player.querySelector('video');
      const button = player.querySelector('.vx-play');
      if (!video || !button) return;
      let engaged = false;
      let autoPausing = false;
      const status = player.querySelector('[data-vx-video-status]');
      const load = () => {
        const source = video.querySelector('source[data-src]');
        if (source) { source.src = window.matchMedia('(max-width: 749px)').matches && source.dataset.mobileSrc ? source.dataset.mobileSrc : source.dataset.src; source.removeAttribute('data-src'); video.load(); }
      };
      button.addEventListener('click', () => { engaged = true; load(); video.play().catch(() => {}); });
      video.addEventListener('play', () => { player.dataset.playing = 'true'; if (status) status.hidden = true; });
      video.addEventListener('pause', () => { player.dataset.playing = 'false'; if (!autoPausing) engaged = true; autoPausing = false; });
      video.addEventListener('error', () => { player.dataset.playing = 'false'; if (status) status.hidden = false; });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              load();
              if (!reduced.matches && !engaged && !navigator.connection?.saveData) video.play().catch(() => {});
            } else if (!video.paused) { autoPausing = true; video.pause(); }
          });
        }, {threshold:0.35});
        observer.observe(player);
      } else load();
    });
  };
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
